"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsx2 = _interopRequireDefault(require("@babel/runtime/helpers/jsx"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = _interopRequireDefault(require("./styles"));

var Logo = function Logo(props) {
  var fill = props.fill;
  return (0, _jsx2["default"])(_styles["default"], {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 225 48"
  }, void 0, (0, _jsx2["default"])("path", {
    fill: fill,
    d: "M24.66,6.48,42.87,19.7,35.92,41.11H13.41L6.46,19.7Zm0-6.48a6.14,6.14,0,0,0-3.58,1.16L2.51,14.65A6.11,6.11,0,0,0,.3,21.47L7.39,43.29a6.1,6.1,0,0,0,5.8,4.22h23a6.1,6.1,0,0,0,5.8-4.21L49,21.47a6.11,6.11,0,0,0-2.22-6.82L28.25,1.16A6.14,6.14,0,0,0,24.66,0Z"
  }), (0, _jsx2["default"])("polygon", {
    fill: fill,
    points: "62.03 39.36 81.87 39.36 81.87 33.61 68.36 33.61 68.36 27.85 80.07 27.85 80.07 22.22 68.36 22.22 68.36 16.84 81.87 16.84 81.87 11.09 62.03 11.09 62.03 39.36"
  }), (0, _jsx2["default"])("path", {
    fill: fill,
    d: "M118.92,34.19c-1.11,0-1.36-.66-1.36-2.18V26.8c0-5.34-2.59-8.59-7.27-8.59-2.87,0-5.46.7-6.82,3.29-.94-2.14-2.79-3.29-5.62-3.29a5.63,5.63,0,0,0-5.38,3V18.66H86.35v20.7h6.12V27.74c0-2.42,1.43-4.11,3.41-4.11S99,25.15,99,27.53V39.36h6.12V27.74c0-2.42,1.39-4.11,3.36-4.11s3,1.52,3,3.9V33.7c0,4.35,2.22,5.91,5.46,5.91.45,0,.84,0,1.17,0a10.59,10.59,0,0,0,2.43-.38V34c-.08,0-.63.11-1,.15C119.45,34.15,119.16,34.19,118.92,34.19Z"
  }), (0, _jsx2["default"])("path", {
    fill: fill,
    d: "M138.78,35.51A9.53,9.53,0,0,1,129,25.84a9.57,9.57,0,0,1,9.76-9.73,10.48,10.48,0,0,1,7.53,3.18L151,15.85a16,16,0,0,0-12.15-5.58c-8.94,0-16.2,6.57-16.2,15.57s7.26,15.51,16.2,15.51a16,16,0,0,0,12.19-5.61l-4.73-3.44A10.42,10.42,0,0,1,138.78,35.51Z"
  }), (0, _jsx2["default"])("path", {
    fill: fill,
    d: "M171,39a6.63,6.63,0,0,0,3.36.74,10.16,10.16,0,0,0,2.76-.33V34.31a8.93,8.93,0,0,1-1,.08c-1.07,0-1.52-.61-1.52-2.3V18.66h-6.12v2.71c-.65-1.58-3-3.08-6.16-3.08C156.39,18.29,152,23.06,152,29s4.4,10.76,10.27,10.76c3.61,0,5.67-1.23,6.86-3A4,4,0,0,0,171,39Zm-7.6-4.8a5.18,5.18,0,1,1,0-10.35,5.18,5.18,0,1,1,0,10.35Z"
  }), (0, _jsx2["default"])("path", {
    fill: fill,
    d: "M192.47,27.08c-4-1.39-5.67-1.15-5.67-2.55,0-.69.66-1.3,2.06-1.3a7.58,7.58,0,0,1,2.41.37l.27.11h0a13,13,0,0,1,1.75.87c.37.22.7.43,1,.6h0l1.51-4.69h0A9.79,9.79,0,0,0,189,18.05a11.32,11.32,0,0,0-2.2.21c-3.25.66-5.85,2.8-5.85,6.44a5.16,5.16,0,0,0,2.28,4.53,9.56,9.56,0,0,0,2.48,1.22c3.17,1.07,6,1.19,6,2.59,0,1-.94,1.68-3.12,1.68a9,9,0,0,1-2.17-.26l-.12,0c-.24-.06-.48-.14-.72-.22a16.38,16.38,0,0,1-2.94-1.45c-.29-.17-.46-.29-.46-.29l-.38,1.2h0l-1.23,3.75v0h0a11.85,11.85,0,0,0,7.84,2.49c6.32,0,9.12-3,9.12-7C197.57,30.33,196.21,28.35,192.47,27.08Z"
  }), (0, _jsx2["default"])("path", {
    fill: fill,
    d: "M224,34.39c-1.07,0-1.52-.61-1.52-2.3V18.66h-6.12v2.71c-.58-1.8-3-3.08-6.16-3.08-5.88,0-10.27,4.77-10.27,10.72s4.39,10.76,10.27,10.76c3.61,0,5.67-1.23,6.86-3A4,4,0,0,0,218.87,39a6.63,6.63,0,0,0,3.36.74A10.16,10.16,0,0,0,225,39.4V34.31A8.93,8.93,0,0,1,224,34.39Zm-12.69-.2a5.18,5.18,0,1,1,0-10.35,5.18,5.18,0,1,1,0,10.35Z"
  }));
};

Logo.propTypes = {
  fill: _propTypes["default"].string
};
Logo.defaultProps = {
  fill: '#ff2b7f'
};
var _default = Logo;
exports["default"] = _default;